import * as Yup from 'yup'

export default Yup.object().shape({
  username: Yup.string()
    .nullable(),
  password: Yup.string()
    .nullable()
})
